// extracted by mini-css-extract-plugin
export default {"grid":"OpqHt8","container":"segJaU","column":"bpKXRE","row":"waM_Qh"};